export default class AddToCart extends HTMLDivElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.events();
    }

    getSelectorUpQuantity() {
        return '.plus';
    }

    getSelectorDownQuantity() {
        return '.minus';
    }

    getSelectorInputQuantity() {
        return "input[name='product-count']";
    }

    getElementInputQuantity() {
        return $( this.getSelectorInputQuantity() )
    }

    events() {

        /* Quantité flech up */
        $(this.getSelectorUpQuantity()).on('click', (e) => {
            e.preventDefault();
            this.updateQuantity( $(e.target).closest( this.getSelectorUpQuantity() ), '+' )
        })

        /* Quantité flech down */
        $(this.getSelectorDownQuantity()).on('click', (e) => {
            e.preventDefault();
            this.updateQuantity( $(e.target).closest( this.getSelectorDownQuantity() ), '-' )
        })

        $(this.getElementInputQuantity()).on('click', (e) => {
            e.preventDefault();
            $(e.target).val('');
        })

        $(".validate").on('click',function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            let qte = $("#product-count").val();

            if(!qte) {
                qte = 1;
            }

            window.HegydCore.initRemoteModal(
                '#modal',
                $(this).attr('href'),
                function(){
                    $('#productQte').html(qte);
                    $('.qte').val(qte);
                    $('#init_new_cart').attr('data-qte', qte);
                    $('#qteMultiply').html($('#qteMultiply').data('unit_price')*qte + " €");
                },
                (data) => {
                    if(data.hasOwnProperty('errors')){
                        if(data.errors.length > 0){
                            toastr.error(data.errors);
                        } else{
                            toastr.success(data.message);
                        }
                    } else{
                        toastr.success(data.message);
                    }
                },
                () => {
                     toastr.error('Une erreur s\'est produite');
                }
            );
        });
    }

    updateQuantity( $element, $operation )
    {
        let val = parseInt( this.getElementInputQuantity().val() );
        if(isNaN(val)) {
            val = 0;
        }
        if($operation === "+"){
            val = val + 1
        }else{
            if(val > 1){
                val = val - 1
            }
        }
        this.getElementInputQuantity().val(val)
        this.getElementInputQuantity().trigger('change');
    }
}
